import { ss } from '@/utils/storage'

const LOCAL_NAME = 'appSetting'

export type Theme = 'light' | 'dark' | 'auto'

export type Language = 'en-US' | 'vi-VN'

const languageMap: { [key: string]: Language } = {
  'en': 'en-US',
  'en-US': 'en-US',
  'vi': 'vi-VN',
  'vi-VN': 'vi-VN',
}

export interface AppState {
  siderCollapsed: boolean
  theme: Theme
  language: Language
  colorTheme: string
  imageChat: string
}

export function defaultSetting(): AppState {
  const language = languageMap[navigator?.language] || 'vi-VN'
  return { siderCollapsed: false, theme: 'light', language, colorTheme: '#764ab9', imageChat: '' }
}

export function getLocalSetting(): AppState {
  const localSetting: AppState | undefined = ss.get(LOCAL_NAME)
  return { ...defaultSetting(), ...localSetting }
}

export function setLocalSetting(setting: AppState): void {
  ss.set(LOCAL_NAME, setting)
}
